import * as React from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { useCallback } from 'react';
import { DirectoryStoreState } from '../../types';
import { getFilteredExtensions } from '../../reducers/extensions';
import { makeIWSCall } from '../../actions';

export interface ExtensionItemProps {
  storeId: number;
  index: number;
  sloc: string;
  number: string;
  isIntegrationUrl: boolean;
}

export const ExtensionItem: React.FC<ExtensionItemProps> = ({
  storeId,
  index,
  sloc,
  number,
  isIntegrationUrl,
}) => {
  const extension = useMappedState(
    useCallback((state: DirectoryStoreState) => getFilteredExtensions(storeId)(state)[index], [
      index,
      storeId,
    ])
  );
  const dispatch = useDispatch();

  const extCode = extension.overridden_code ? extension.overridden_code : extension.code;
  const isOldClass = extension.overridden_code ? 'extensions-code-old' : '';
  const integrationLinkClass = isIntegrationUrl ? 'iws-link' : '';

  function onClick(e: React.MouseEvent<HTMLAnchorElement>) {
    if (isIntegrationUrl) {
      e.preventDefault();
      dispatch(makeIWSCall(`${sloc}${extCode}`));
    }
  }

  return (
    <div className="extensions-item">
      {extension.name}{' '}
      <a className={integrationLinkClass} href={`tel:${number},${extCode}`} onClick={onClick}>
        {sloc}&nbsp;
        {extension.overridden_code && <span>{extension.overridden_code}&nbsp;</span>}
        <span className={isOldClass}>{extension.code}</span>
      </a>
    </div>
  );
};
